import request from '@/router/axios'

// 设备监控点数据
export function getcurrent(param) {
    return request({
      url: `/api/data/monitor/multiple/current`,
      method: 'get',
      params: param
    });
}
// 修改监控点
export function getwrite(param) {
    return request({
        url: `/api/data/monitor/multiple/write`,
        method: 'POST',
        data: param
    });
}
// 修改网关
export function gateway(param) {
    return request({
        url: `/api/gateway`,
        method: 'put',
        data: param
    });
}


// 监控点查询
export function getmonitorlist(param) {
    return request({
      url: `/api/data/monitor/list`,
      method: 'get',
      params: param
    });
}

// 导入、上传表格
export function importExcel(param) {
  return request({
    url: `/api/gateway/import`,
    method: 'post',
    data: param
  });
}

export function onenetHisQue (param) {
    return axios({
      url: `http://onenet.zn.thingcom.com/devices/${param.deviceId}/datapoints`,
      method: 'get',
      headers: {
        'api-key': "9k9eLA2cyR4efBAn49nb2zmnE0k="
      },
      params:param
    })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        console.log(error)
      })
  }
  
  //?datastream_id=${param.datastreamId}&start=${param.startTime}&end=${param.endTime}&limit=${param.limit} cursor